export class QuestionFieldSaveModel {
    

    constructor(id,fieldName,value){
        this.onlineEnrollmentConfigurationId=id;
        this.fieldName=fieldName;
        this.value=value;
    }
    // ONLINEENROLLMENTCONFIGURATIONID
    public onlineEnrollmentConfigurationId: number;
    // FIELDNAME
    public fieldName: string;
    // VALUE
    public value: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/question-save-model.ts